/** Styl komponenty paginator k tématu Erma */
export const PaginatorStyles = {
  padding: '.5rem',
  borderRadius: '0',
  gap: '.1rem',
  borderWidth: '0px 1px 1px 1px',
  background: 'var(--erma-secondary-40)',
  extend: {
    nav: {
      button: {
        width: '2.357rem',
        height: '2.357rem',
        first: {
          marginLeft: 'auto'
        },
        selected: {
          background: 'var(--erma-primary-500)',
          color: 'var(--erma-secondary-0)'
        }
      }
    }
  },
  css: ({ dt }) => `
        div.p-paginator {
            border-width: ${dt('paginator.borderWidth')};
        }
        div.p-paginator .p-paginator-first {
          margin-left: ${dt('paginator.nav.button.first.marginLeft')};
        }`
};
